import { render, staticRenderFns } from "./manage-objective.vue?vue&type=template&id=1dbb9422&scoped=true"
import script from "./manage-objective.vue?vue&type=script&lang=js"
export * from "./manage-objective.vue?vue&type=script&lang=js"
import style0 from "./manage-objective.vue?vue&type=style&index=0&id=1dbb9422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb9422",
  null
  
)

export default component.exports